import UserStatus from '../UserStatus/UserStatus';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import getUserStatusDetail from '../UserStatus/state.get.user.status.detail';

function UserStatusWithDetailsPopover({
  isProfile,
  user,
  username,
  userId,
  currentUser,
  course,
  actions,
  breadCrumb,
}) {
  const { userStatus } =
    user && !user.isLoading ? getUserStatusDetail(user, currentUser) : {};
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user && !loading) {
      setLoading(true);
      actions.getUserDetails(username, userId).then(() => setLoading(false));
    }
  }, []);

  if (!user || user.isLoading) {
    return null;
  }

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.body.click();
  };

  return (
    <UserStatus
      isProfile={isProfile}
      user={user}
      course={course}
      breadCrumb={breadCrumb}
    >
      <div
        className={`user-status-container ${
          !isProfile ? 'relative' : 'absolute'
        }`}
        onClick={handleClick}
      >
        <div className={`user-status ${userStatus}`}></div>
      </div>
    </UserStatus>
  );
}

function mapStateToProps(state, ownProps) {
  let { username, userId } = ownProps;
  const { byUsername, byId } = state.user.usersWithDetails;

  if (!username && !userId) {
    username = ownProps.user?.username ?? state.user.user.username;
  }

  return {
    user:
      state.user.user.username === username
        ? state.user.user
        : byUsername[username] || byId[userId],
    username,
    userId,
    currentUser: state.user.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserStatusWithDetailsPopover);
